import { FC, useCallback, useContext } from 'react'
import { IconButton, ModalContext, ModalHeader } from '@cargomart/ui'
import { notify } from 'components/extend/Notification/NotificationEmitter'
import { getEnv } from 'helpers/common'
import some from 'lodash/some'
import IconFileCopy from 'remixicon/icons/Document/file-copy-line.svg?react'
import IconClose from 'remixicon/icons/System/close-line.svg?react'
import IconMore from 'remixicon/icons/System/more-2-fill.svg?react'
import { OrderAccess, OrderItem } from 'schema'
import { MODAL_IDS, useModal } from 'src/components'

import { formattedSerialId } from '../../helpers'
import OrderAction from '../OrderAction'

interface OrderYarcheDetailDesktopHeaderProps {
  order: OrderItem
}

const OrderYarcheDetailDesktopHeader: FC<OrderYarcheDetailDesktopHeaderProps> = (props) => {
  const { order } = props
  const { onClose } = useContext(ModalContext)
  const { openModal } = useModal()
  const isShowAction = some(order?.access, (current) => Boolean(current))

  const handleCancel = useCallback(() => {
    openModal(MODAL_IDS.CancelOrder)
  }, [openModal])

  const handleCopyOrderTracking = useCallback(() => {
    if (!order?.barcode) {
      return
    }

    const { barcode } = order
    const link = `${getEnv('VITE_REACT_APP_LANDING_URL')}/tracking/${barcode}`

    navigator.clipboard.writeText(link).then(() => {
      notify({ type: 'success', title: 'Ссылка на историю перевозки скопирована' })
    })
  }, [order])

  return (
    <ModalHeader isBgSurface isSticky className="py-4 pl-4 pr-22" isShadow={false}>
      <div className="grid grid-cols-[61.5%_auto] gap-x-8 lg:gap-x-18">
        <div className="flex gap-x-4">
          <IconButton className="mr-4" onClick={onClose} size="lg">
            <IconClose size="nm" />
          </IconButton>
          <div className="self-center text-headline-md">{formattedSerialId(order?.serialId)}</div>
          {isShowAction && (
            <OrderAction
              access={order?.access as OrderAccess}
              id={order.id}
              onCancel={handleCancel}
              trigger={
                <IconButton size="lg" title="Действия">
                  <IconMore containerSize="lg" size="nm" />
                </IconButton>
              }
            />
          )}
        </div>
        {order?.barcode && (
          <div className="flex items-center justify-end lg:justify-start">
            <div className="text-headline-md">Трек&nbsp;&#8470;&nbsp;{order.barcode}</div>
            <IconButton onClick={handleCopyOrderTracking} size="lg">
              <IconFileCopy size="nm" />
            </IconButton>
          </div>
        )}
      </div>
    </ModalHeader>
  )
}

export default OrderYarcheDetailDesktopHeader
